import { useId, type ReactNode } from 'react'

import { cn } from '@/common/lib/cn/cn'

import emptyCatalogIllustration from './assets/empty-catalog.png'
import linkChainIllustration from './assets/link-chain.png'

type Image = 'empty-catalog' | 'link-chain'

const IMAGES: Record<Image, string> = {
    'empty-catalog': emptyCatalogIllustration,
    'link-chain': linkChainIllustration,
}

const DEFAULT_TITLE = 'Каталог пуст'

export type NonIdealStateProps = {
    title?: string
    description: ReactNode
    actionSlot?: ReactNode
    imageAlt?: string
    className?: string
    image: Image
}

export const NonIdealState = ({
    title = DEFAULT_TITLE,
    description,
    actionSlot,
    image,
    imageAlt = 'Пустой каталог',
    className,
}: NonIdealStateProps) => {
    const titleId = useId()

    return (
        <section
            className={cn('flex w-full max-w-[560px] flex-col items-center rounded-xl p-10 text-center', className)}
            aria-labelledby={titleId}
        >
            <div className='flex w-full flex-col items-center gap-4'>
                {image && (
                    <div className='relative size-[200px] shrink-0 overflow-hidden'>
                        <img
                            src={IMAGES[image]}
                            alt={imageAlt}
                            className='size-full object-contain object-center'
                            loading='lazy'
                            decoding='async'
                        />
                    </div>
                )}

                <div className='flex w-full max-w-[520px] flex-col items-center gap-6 pb-6 leading-[1.4]'>
                    <h2 id={titleId} className='text-[30px] font-medium whitespace-normal text-white'>
                        {title}
                    </h2>
                    {typeof description === 'string' ? (
                        <p className='text-base text-[var(--gray-2,#aba7af)]'>{description}</p>
                    ) : (
                        <div className='w-full text-base text-[var(--gray-2,#aba7af)]'>{description}</div>
                    )}
                </div>

                {actionSlot}
            </div>
        </section>
    )
}
